import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import RequireAdmin from './components/RequireAdmin';
import AgenciaAvisosCreditos from './pages/AgenciaAvisosCreditos';
import AgenciaCrmGate from './pages/AgenciaCrmGate';
import AgenciaDetail from './pages/AgenciaDetail';
import AgenciaLanzamiento from './pages/AgenciaLanzamiento';
import AgenciaLiveFest from './pages/AgenciaLiveFest';
import AgenciaPreventa from './pages/AgenciaPreventa';
import AgenciaRestos from './pages/AgenciaRestos';
import AgenciaSolicitudes from './pages/AgenciaSolicitudes';
import Agencias from './pages/Agencias';
import AgencyReferenceLayout from './pages/AgencyReferenceLayout';
import Beta from './pages/Beta';
import Cupones from './pages/Cupones';
import Dashboard from './pages/Dashboard';
import Eventos from './pages/Eventos';
import Founders from './pages/Founders';
import Gaming from './pages/Gaming';
import Inicio from './pages/Inicio';
import Login from './pages/Login';
import Popups from './pages/Popups';
import Sonidos from './pages/Sonidos';
import Tracking from './pages/Tracking';
import UserDetail from './pages/UserDetail';
import Users from './pages/Users';
import Widgets from './pages/Widgets';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <RequireAdmin>
            <Layout />
          </RequireAdmin>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="users/:uid" element={<UserDetail />} />
        <Route path="eventos" element={<Eventos />} />
        <Route path="founders" element={<Founders />} />
        <Route path="popups" element={<Popups />} />
        <Route path="inicio" element={<Inicio />} />
        <Route path="cupones" element={<Cupones />} />
        <Route path="agencias" element={<AgenciaCrmGate />} />
        <Route path="agencias/crm" element={<Navigate to="/agencias" replace />} />
        <Route element={<AgencyReferenceLayout />}>
        <Route path="agencias/consulta" element={<Agencias />} />
        <Route path="agencias/solicitudes" element={<AgenciaSolicitudes />} />
        <Route path="agencias/avisos-creditos" element={<AgenciaAvisosCreditos />} />
        <Route path="agencias/lanzamiento" element={<AgenciaLanzamiento />} />
        <Route path="agencias/live-fest" element={<AgenciaLiveFest />} />
        <Route path="agencias/preventa" element={<AgenciaPreventa />} />
        <Route path="agencias/restos" element={<AgenciaRestos />} />
        <Route path="agencias/:id" element={<AgenciaDetail />} />
        </Route>
        <Route path="tracking" element={<Tracking />} />
        <Route path="widgets" element={<Widgets />} />
        <Route path="gaming" element={<Gaming />} />
        <Route path="sonidos" element={<Sonidos />} />
        <Route path="beta" element={<Beta />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
